import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=3bb4c0dd&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb4c0dd')) {
      api.createRecord('3bb4c0dd', component.options)
    } else {
      api.reload('3bb4c0dd', component.options)
    }
    module.hot.accept("./EndScreen.vue?vue&type=template&id=3bb4c0dd&", function () {
      api.rerender('3bb4c0dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EndScreen.vue"
export default component.exports